import Assignee from 'models/assignee';
import { canCreateEmailComposition, defaultFromForInbox } from './create_email_composition';
import CreateComposition from './lib/create_composition';
import nextDay from 'scripts/lib/next_day';
import ThirdPartyEmailCompositionContent from 'models/composition/third_party_email_composition_content';

class CreateThirdPartyEmailComposition extends CreateComposition {
  constructor(context) {
    super(context, ThirdPartyEmailCompositionContent);
  }

  // The task that holds the thread defaults to the sending agent in the conversation's inbox, and the
  // mail leaves from that inbox's address: replies route back by it. With no inbox to borrow, the
  // agent picks the assignee before sending.
  _createContent({ conversation }) {
    const routingGroupId = conversation?.assignee?.routingGroupId;
    return new ThirdPartyEmailCompositionContent({
      assignee: routingGroupId
        ? new Assignee({ agentId: this.context.stores.currentAgent.get().id, routingGroupId })
        : undefined,
      dueAt: nextDay(),
      from: defaultFromForInbox(this.context, routingGroupId),
      to: '',
    });
  }

  _canCreateComposition() {
    return canCreateEmailComposition(this.context);
  }
}

export default CreateThirdPartyEmailComposition;
